jQuery.fn.setAllToMaxHeight = function(){
   return this.height( Math.max.apply(this, jQuery.map( this , function(e){ return jQuery(e).height() }) ) );
}

var slideDuration = 8000;
var slideTransition = 'scrollHorz';

function showBackTop(posTop){
    if (posTop > 200) {
        $('#back-top').fadeIn(200);
    } else {
        $('#back-top').fadeOut(200);
    } 
}

// AI3.0 Bet 8: doResize early-return — selectors only exist on homepage and
// collection pages. On PDPs / cart / pages, both queries return empty sets but
// jQuery still walks the DOM on every debounced resize. Gate the function +
// only bind the resize handler when at least one selector matches at startup.
// See OUTPUT/_AI3_AUDIT_SITE_JS.md finding #4.
function doResize(){
   var $homeThumbs = $('body#index ul.collection-list .thumbnail');
   var $colTh = $('ul.collection-th li a.prod-th');
   if (!$homeThumbs.length && !$colTh.length) return;
   if ($homeThumbs.length) $homeThumbs.removeAttr("style").setAllToMaxHeight();
   if ($colTh.length) $colTh.removeAttr("style").setAllToMaxHeight();
}

// resize but not too often — only bind if doResize has work to do on this template
jQuery(function($){
    if ($('body#index ul.collection-list .thumbnail').length || $('ul.collection-th li a.prod-th').length) {
        var resizeDelay;
        $(window).resize(function() {
            clearTimeout(resizeDelay);
            resizeDelay = setTimeout(function() {
                doResize();
            }, 50);
        });
    }
});

//ipad refresh on rotate
/*
if (window.addEventListener) {
    window.addEventListener("orientationchange", function() {
        window.location.reload();
    }, false);
}
*/

// AI3.0 Bet 5: removed `$.fn.preload` jQuery extension + the per-PDP gallery
// preload loop (lines 252-257 below) — preloading full-size lightbox images
// before user opens them competed with LCP image for bandwidth, no measurable
// benefit. See OUTPUT/_AI3_AUDIT_SITE_JS.md finding #3.

jQuery(document).ready(function($){

    if ($.fn.imagesLoaded) {
        $('ul.collection-th .thumbnail').imagesLoaded(function() {
            doResize();
        });
    } else {
        doResize();
    }

    $(document).on('click', '#menu .top-search .icon-magnifier', function(){
        var $topSearch = $('#menu .top-search');
        $topSearch.toggleClass('active');
        if ($topSearch.hasClass("active")){
            $topSearch.find('input').focus();
        }
    });

    $(document).on('click', "span.quick-view, img.quick-view-img, span.quick-view-span", function(e){ 
        e.preventDefault();
        e.stopPropagation();
        $.magnificPopup.open({
            items: {
              src: $(this).data('prdid'),
              type: 'inline'
            }
        });
    });

    if ($(window).width() > 900) {  
        $(".prod-th").mouseenter(function(e){
            $(".quick-view").hide();
            $(".quick-view", this).stop().fadeIn(300);
        }).mouseleave(function(e){
            $(".quick-view").hide();
        });
    }

    var $mobileNav = $("<div class='mobile-nav'><a class='mobile-button' id='show-nav' href='#'><span class='icon-list'></span> MENU</a><a class='mobile-button' id='mini-cart' href='/cart'><span class='icon-cart3'></span>CART</a></div>");
    var $menu = $("#menu");
    // clone menu for mobile and remove id
    var $newNav = $menu.clone();
    $newNav.removeAttr('id');
    $newNav.addClass('mobile-menu');
    $mobileNav.append($newNav);

    $("body").prepend($mobileNav);
    
    $newNav.find('li.has-sub > a').each(function() {
        var tis = $(this);
        var state = false;
        var subMenu = tis.next('ul').slideUp();
        tis.on('click', function(e) {
            e.preventDefault();
            state = !state;
            subMenu.slideToggle(state);
            tis.closest('li').toggleClass('active',state);
        });
    });

    $('#show-nav').on('click', function(e) {
        e.preventDefault();
        $("ul.mobile-menu").slideToggle();
    });

    function initMenu(){
        $menu.find('.open').removeClass('open');
    }

    $(document).on('click', '#menu.click-me .has-sub > a', function(e){
        // handle desktop menu clicks
        e.preventDefault();
        e.stopPropagation();
        var $this = $(this);
        var $thisParent = $this.parent();
        if ($thisParent.hasClass('level-1')){
            if ($thisParent.hasClass('open')){
                initMenu();
            } else {
                initMenu();
                $thisParent.addClass('open');
                $this.next('ul').toggleClass('open');
            }
        } else {
            if ($this.next('ul').hasClass('open')){
                // hide the sub attached to this link
                $thisParent.find('ul').removeClass('open');
            } else {
                // close any open subs and then open sub attached to this link
                $this.closest('ul.open').find('ul').removeClass('open');
                $this.next('ul').addClass('open');
            }
        }
    });
  
var $slides = $('#slides');

if ($slides.length && typeof $slides.cycle === 'function') {

    if($slides.find("div").length === 1){
      $slides.parent().addClass('single-slide');
    }

    $slides.before("<div class='slide-prev'><span class='icon-arrow-large-left'></span></div><div class='slide-next'><span class='icon-arrow-large-right'></span></div>");
    $slides.after("<div class='slide-pager'></div>");

    $slides.find('img').each(function(){
        $('#slideshow .slide-pager').append("<a href='#'></a>");
    });

    $slides.on( 'cycle-update-view', function( e, opts ) {
        // show captions
        var currSlide = $(this);
        currSlide.find('.caption1').addClass('animate1');
        currSlide.find('.caption2').addClass('animate2');
        currSlide.find('.cta').addClass('animate2');
    });

    $slides.on( 'cycle-before', function( e, opts ) {
        // hide captions
        var slideshow = $(this);
        var img = slideshow.find('.caption').removeClass('animate1').removeClass('animate2');
    });

    $slides.cycle({
        timeout: slideDuration,
        fx: slideTransition,
        slides: '.slide',
        prev: '.slide-prev',
        next: '.slide-next',
        pager: '#slideshow .slide-pager',
        swipe: true,
        easing: 'easeOutQuint',
        pagerTemplate: ''
    });
}
    
    $(window).scroll(function() {
        showBackTop($(this).scrollTop());
    });

    // Animate the scroll to top
    $('#back-top').on('click', function(event) {
        event.preventDefault();
        $('html, body').animate({scrollTop: 0}, 300);
    });

    // Gallery for product with single image
    $('#product-images.single-image #product-shot').magnificPopup({
        type: 'image'
    });
  
    // Gallery for product with multiple images
    var prdImages = [];
    var $prdImg = $('#more-images a');
    $prdImg.each(function(){
        prdImages.push({
            src: $(this).prop('href'),
            title: $(this).find('img').prop('alt'),
            type: $(this).attr("data-type")
        });
    });

    $('#product-images.multi-image #product-shot').on('click',function(e){
        // show lightbox popup for all images 
        e.preventDefault();
        $.magnificPopup.open({
            items: prdImages,
            delegate: 'a',
            tLoading: 'Loading image #%curr%...',
            mainClass: 'mfp-img-mobile',
            gallery: {
                enabled: true,
                navigateByImgClick: true,
                preload: [0,1]
            },

            iframe : {
                markup: '<div class="mfp-iframe-scaler">'+
                          '<div class="mfp-close"></div>'+
                          '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
                        '</div>',
                patterns: {
                  youtube: {
                    index: 'youtube.com/',
                    id: 'v=',
                    src: '//www.youtube.com/embed/%id%?autoplay=1' 
                  },
                  vimeo: {
                    index: 'vimeo.com/',
                    id: '/',
                    src: '//player.vimeo.com/video/%id%?autoplay=1'
                  },
                  gmaps: {
                    index: '//maps.google.',
                    src: '%id%&output=embed'
                  }
                },
                srcAction: 'iframe_src',
            }
        });
    });
  
    // AI3.0 Bet 5: removed gallery image preload loop. Was preloading
    // full-size lightbox images on every PDP load before user opens them.
    // Anti-LCP behaviour, no measurable benefit. magnific-popup fetches
    // the images on open.

    function YouTubeGetID(url){
       // AI3.4: detect playlist URLs (youtube.com/playlist?list=PL...) and return
       // the proper embed-path segment. The caller prepends
       // 'https://www.youtube.com/embed/' so the final URL is correctly
       // /embed/videoseries?list=ID&rel=0 for playlists, or /embed/<VID>?rel=0
       // for single videos. rel=0 limits "More videos" overlay to same channel
       // (post-2018 YouTube behavior — no longer fully disables related videos).
       //
       // Previous behavior fell back to returning the entire URL when no
       // delimiter matched, producing malformed embeds like
       // /embed/https://www.youtube.com/playlist?list=... that YouTube
       // tolerated empirically but emit a broken canonical URL.
       // AI3.4: detect playlist URLs by presence of /playlist or /videoseries
       // segment ANYWHERE in the URL (no immediate-? requirement). Shopify's
       // French typography rules auto-inject `&nbsp;` before `?`, `!`, `:`, `;`
       // on /fr/* pages, so a URL like `https://www.youtube.com/playlist?list=...`
       // gets munged to `https://www.youtube.com/playlist&nbsp;?list=...` only
       // on FR. A regex requiring `/playlist?` to be contiguous misses FR.
       // The looser /\/playlist|\/videoseries/ matches across all locales.
       var listMatch = url.match(/[?&]list=([A-Za-z0-9_-]+)/);
       if (listMatch && /\/playlist|\/videoseries/.test(url)) {
         return 'videoseries?list=' + listMatch[1] + '&rel=0';
       }
       var parts = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
       if (parts[2] !== undefined) {
         var videoId = parts[2].split(/[^0-9a-z_\-]/i)[0];
         // If a `list=` param is also present (single video within a playlist),
         // preserve the playlist context so "next/prev" works.
         if (listMatch) return videoId + '?list=' + listMatch[1] + '&rel=0';
         return videoId + '?rel=0';
       }
       return parts[0];
    }
  
    function buildResponsiveProductImageSet(imageUrl) {
    var queryIndex = imageUrl.indexOf('?');
    var cleanUrl = queryIndex === -1 ? imageUrl : imageUrl.substring(0, queryIndex);
    var queryString = queryIndex === -1 ? '' : imageUrl.substring(queryIndex);

    // Remove Shopify size suffix like _1000x1000, _600x600, etc.
    cleanUrl = cleanUrl.replace(/_(\d+x\d+)(?=\.[a-zA-Z]+$)/, '');

    function buildSizedImageUrl(size) {
        return cleanUrl.replace(/(\.[a-zA-Z]+)$/, '_' + size + '$1') + queryString;
    }

    return {
        src: buildSizedImageUrl('600x600'),
        srcset:
            buildSizedImageUrl('400x400') + ' 400w, ' +
            buildSizedImageUrl('600x600') + ' 600w, ' +
            buildSizedImageUrl('800x800') + ' 800w, ' +
            buildSizedImageUrl('1000x1000') + ' 1000w',
        sizes: '(max-width: 767px) 100vw, 50vw',
        href: buildSizedImageUrl('1000x1000')
    };
}

function updateMainProductImage($context, imageUrl, imageId) {
    var imageSet = buildResponsiveProductImageSet(imageUrl);
    var $mainImg = $('#image-product', $context);
    var $mainLink = $('#product-shot', $context);

    if (!$mainImg.length || !$mainLink.length) {
      return;
    }

    $mainImg
        .attr('src', imageSet.src)
        .attr('srcset', imageSet.srcset)
        .attr('sizes', imageSet.sizes);

    $mainLink.attr('href', imageSet.href);

    if (imageId) {
      $('#more-images a', $context).removeClass('active-img');
      $('a#' + imageId, $context).addClass('active-img');
    }

    $('#image-product', $context).css('display', "");
    $('.sticker-new', $context).css('display', "");
    $('.sticker-sale', $context).css('display', "");
    $('.icon-magnifier', $context).css('display', "");
    $('#ifrm', $context).remove();
}

function updateQuickviewMainImage($context, imageUrl) {
    var imageSet = buildResponsiveProductImageSet(imageUrl);
    var $mainImg = $('.main-image img', $context).first();

    if (!$mainImg.length) {
      return;
    }

    $mainImg
      .attr('src', imageSet.src)
      .attr('srcset', imageSet.srcset)
      .attr('sizes', imageSet.sizes);
}

    $("#more-images a").on('click',function(e){
        // swap main image when a thumb is clicked
        e.preventDefault();

        var href = $(this).prop('href');
        var typevar = $(this).attr("data-type");

        $("#more-images a").removeClass('active-img');
        $(this).addClass('active-img');
        if(typevar == 'image'){
            // AI3.0 Bet 6: removed 5 duplicate CSS writes here — `updateMainProductImage`
            // already does the same writes scoped to `$context`. See OUTPUT/_AI3_AUDIT_SITE_JS.md
            // finding #6. The redundant duplicate writes were unscoped (touching
            // the whole document) and the broken indentation suggests they were
            // a copy-paste accident.
            updateMainProductImage($(document), href);
        } else if(typevar == 'iframe'){
            $("#ifrm").remove();
            var hrefIframe = YouTubeGetID(href);
            var endHref = 'https://www.youtube.com/embed/'+hrefIframe;

            // AI3.4: capture the product image's currently-rendered width
            // BEFORE we hide it. The parent <a.productimage> is inline-block
            // (sizes to its content). An empty iframe has no intrinsic width
            // so width:100% can't expand — the parent collapses around the
            // 300px default. By passing the image's rendered width to the
            // iframe explicitly, the iframe occupies the same gallery slot
            // the image was filling — matching responsive behavior at all
            // viewport widths.
            var $img = $("#image-product");
            var galleryWidth = $img.length ? $img[0].getBoundingClientRect().width : 0;

            var ifrm = document.createElement('iframe');
            ifrm.setAttribute('id', 'ifrm');
            var el = document.getElementById('id-iframe');
            el.parentNode.insertBefore(ifrm, el);
            ifrm.setAttribute('src', endHref);
            ifrm.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
            ifrm.setAttribute('allowfullscreen', '');
            if (galleryWidth > 0) {
              ifrm.style.width = galleryWidth + 'px';
              ifrm.style.height = (galleryWidth * 9 / 16) + 'px';
            }
            $img.css('display','none');
            $(".sticker-new").css('display','none');
            $(".sticker-sale").css('display','none');
            $(".icon-magnifier").css('display','none');
        }
    });

    $('a.go-back').on('click', function(e) {
        e.preventDefault();
        window.history.back();
    });

    $('a.cart-update').on('click', function(e) {
        e.preventDefault();
        $('form#cartform').submit();
    });
   
    if ($.fn.fitVids) {
        $("#content").fitVids();
    }

    // hide big footer if no content
    var $bigFooter = $('.social-row .inner > div');
    var bigFootCnt = $bigFooter.find("div").length;
    if (bigFootCnt === 0){
        $('.social-row').hide();
    }
    
    $('.social-icons a').prop('target','_blank');

    var owl = $("#more-images");
    if (owl.length && typeof owl.owlCarousel === 'function') {
        owl.owlCarousel({
           itemsCustom : [
              [0, 1],
              [320, 2],
              [640, 3]
           ],
           items : 3,
           rewindSpeed : 400,
           navigation:true,
           navigationText : ["<span class='icon-arrow-large-left'></span>","<span class='icon-arrow-large-right'></span>"]
        });
    }
     
    if (window.RESPONSIVEUI && typeof RESPONSIVEUI.responsiveTabs === 'function') {
        RESPONSIVEUI.responsiveTabs();
    }

    $('.gt-accordion h4').each(function() {
       var tis = $(this), state = false, answer = tis.next('div').slideUp();
       tis.click(function() {
          state = !state;
          answer.slideToggle(state);
          tis.toggleClass('active',state);
       });
    });

    $('#review-summary').on('click',function(e){
        var $target = $('#stamped-main-widget');

        if (!$target.length) {
            return;
        }

        e.preventDefault();
        $('html, body').animate({
           scrollTop: $target.offset().top
        }, 1200);
    });

    // product variant callback
    var currencyFormat = $('body').data('curr-format');

    var themeI18nProducts = (window.theme && window.theme.i18n && window.theme.i18n.products) || {};

    function getInventoryButtonText(inventoryState) {
      if (inventoryState === "backorder") {
        return themeI18nProducts.back_order || "Back-Order Now";
      }

      if (inventoryState === "preorder") {
        return themeI18nProducts.pre_order || "Pre-Order Now";
      }

      return themeI18nProducts.add_to_cart || "Add to Cart";
    }

    function getQuickviewInventoryStatusHtml(inventoryState) {
      if (inventoryState === "custom") {
        return themeI18nProducts.inventory_made_to_order_html || '<span style="color: green; font-weight: bold;">Made to Order.</span>&nbsp;&nbsp;View full product details for detailed shipping information.';
      }

      if (inventoryState === "highdemand") {
        return themeI18nProducts.inventory_high_demand_html || '<span style="color: orange; font-weight: bold;">High Demand Item.</span>&nbsp;&nbsp;View full product details for detailed shipping information.';
      }

      if (inventoryState === "backorder") {
        return themeI18nProducts.back_order_status_html || '<span style="color: orange; font-weight: bold;">Available on Back-Order.</span>&nbsp;&nbsp;View full product details for detailed shipping information.';
      }

      if (inventoryState === "preorder") {
        return themeI18nProducts.pre_order_status_html || '<span style="color: orange; font-weight: bold;">Available for Pre-Order.</span>&nbsp;&nbsp;View full product details for detailed shipping information.';
      }

      return themeI18nProducts.inventory_in_stock_html || '<span style="color: green; font-weight: bold;">In Stock!</span>&nbsp;&nbsp;View full product details for detailed shipping information.';
    }

    function getQuickviewInventoryConfig(productId) {
      if (
        window.quickviewInventoryStates &&
        window.quickviewInventoryStates[productId]
      ) {
        return window.quickviewInventoryStates[productId];
      }

      return null;
    }

    function resolveQuickviewInventoryState(productId, variant) {
      var quickviewInventoryConfig = getQuickviewInventoryConfig(productId);

      if (!quickviewInventoryConfig) {
        return "";
      }

      return (
        (quickviewInventoryConfig.variants &&
          variant &&
          (quickviewInventoryConfig.variants[variant.id] ||
            quickviewInventoryConfig.variants[String(variant.id)])) ||
        quickviewInventoryConfig.productState ||
        ""
      );
    }

    function getUnavailableMessageHtml(variant) {
      if (variant) {
        return "<strong>" + (themeI18nProducts.out_of_stock || "Sorry, this product is temporarily out of stock.") + "</strong>";
      }

      return "<strong>" + (themeI18nProducts.unavailable || "Sorry, this product is unavailable.") + "</strong>";
    }

    function togglePurchaseStateUI($scope, isPurchasable) {
      if (!$scope || !$scope.length) {
        return;
      }

      if (isPurchasable) {
        $('.quick-actions', $scope).show();
        $('.quickview-shipping-status', $scope).show();
        $('.product-shipping-status', $scope).show();
      } else {
        $('.quick-actions', $scope).hide();
        $('.quickview-shipping-status', $scope).hide();
        $('.product-shipping-status', $scope).hide();
        $('.quickview-inventory-status', $scope).html('');
      }
    }

    function getScopedQuickviewStatus($product) {
      return $product.find('.quickview-inventory-status').filter(function() {
        var $owner = $(this).closest('[id^="prod-"], [id^="prod2-"]');
        return $owner.length > 0 && $owner[0] === $product[0];
      }).first();
    }

    function refreshAccessoryAddAllForms() {
      $('.accessory-add-all-form').each(function() {
        var $form = $(this);
        var validInputCount = $('.accessory-add-all-input', $form).filter(function() {
          return !this.disabled && !!this.value;
        }).length;
        var $button = $('.btn-recommended', $form).first();

        if (validInputCount > 0) {
          $button.prop('disabled', false).removeClass('disabled');
        } else {
          $button.prop('disabled', true).addClass('disabled');
        }
      });
    }

    function syncAccessoryAddAllInputs(productId, variant) {
      var $inputs = $('.accessory-add-all-input[data-accessory-product-id="' + productId + '"]');

      if (!$inputs.length) {
        return;
      }

      if (variant && variant.available === true) {
        $inputs.each(function() {
          this.value = variant.id;
          this.disabled = false;
        });
      } else {
        $inputs.prop('disabled', true);
      }

      refreshAccessoryAddAllForms();
    }

    function updateQuickviewInventoryUI($product, productId, variant) {
      var $quickviewStatus = getScopedQuickviewStatus($product);

      if (!$quickviewStatus.length) {
        return;
      }

      if (!variant || variant.available !== true) {
        $quickviewStatus.html('');
        return;
      }

      var resolvedInventoryState = resolveQuickviewInventoryState(productId, variant);

      $('.purchase', $product).text(getInventoryButtonText(resolvedInventoryState));
      $quickviewStatus.html(getQuickviewInventoryStatusHtml(resolvedInventoryState));
    }

    refreshAccessoryAddAllForms();

    function ensureShopPromiseHideStyles() {
      if (document.getElementById('shop-promise-visibility-styles')) {
        return;
      }

      var style = document.createElement('style');
      style.id = 'shop-promise-visibility-styles';
      style.textContent = [
        'body.hide-shop-promise delivery-promise-wc,',
        'body.hide-shop-promise #generic-promise-wc,',
        'body.hide-shop-promise [slot="generic-promise"],',
        'body.hide-shop-promise shop-promise-pdp,',
        'body.hide-shop-promise shop-promise,',
        'body.hide-shop-promise shopify-shop-promise { display:none !important; visibility:hidden !important; }'
      ].join(' ');
      document.head.appendChild(style);
    }

    function getCurrentSelectedVariantId() {
      var $variantField = $('#cart-form [name="id"]').first();

      if (!$variantField.length) {
        return '';
      }

      return String($variantField.val() || '');
    }

    function normalizeInventoryState(inventoryState) {
      return String(inventoryState || '').replace(/^\s+|\s+$/g, '').toLowerCase();
    }

    function getCurrentProductInventoryState() {
      var selectedVariantId = getCurrentSelectedVariantId();
      var variantState = '';

      if (
        selectedVariantId &&
        window.variantInventoryStates &&
        Object.prototype.hasOwnProperty.call(window.variantInventoryStates, selectedVariantId)
      ) {
        variantState = normalizeInventoryState(window.variantInventoryStates[selectedVariantId]);
      }

      return variantState || normalizeInventoryState(window.productInventoryState || window.variantInventoryState || '');
    }

    function shouldHideShopPromiseForInventoryState(inventoryState) {
      return (
        inventoryState === 'custom' ||
        inventoryState === 'highdemand' ||
        inventoryState === 'backorder' ||
        inventoryState === 'preorder'
      );
    }

    function shouldHideShopPromiseForShippingCalendar() {
      try {
        return !!(
          window.CustomLEDShippingCalendar &&
          typeof window.CustomLEDShippingCalendar.shouldHideShopPromiseForCalendar === 'function' &&
          window.CustomLEDShippingCalendar.shouldHideShopPromiseForCalendar()
        );
      } catch (error) {
        if (window.console && typeof window.console.warn === 'function') {
          window.console.warn('Custom LED Shop Promise calendar check failed:', error);
        }

        return false;
      }
    }

    function shouldHideShopPromise() {
      var inventoryState = getCurrentProductInventoryState();

      return (
        window.variantAvailable !== true ||
        shouldHideShopPromiseForInventoryState(inventoryState) ||
        shouldHideShopPromiseForShippingCalendar()
      );
    }

    function applyShopPromiseVisibility() {
      if (!$('body#product').length) {
        return;
      }

      ensureShopPromiseHideStyles();

      var shouldHide = shouldHideShopPromise();
      var $targets = $('delivery-promise-wc, #generic-promise-wc, [slot="generic-promise"], shop-promise-pdp, shop-promise, shopify-shop-promise');

      $('body').toggleClass('hide-shop-promise', shouldHide);

      $targets.each(function() {
        if (shouldHide) {
          this.style.setProperty('display', 'none', 'important');
          this.style.setProperty('visibility', 'hidden', 'important');
          this.setAttribute('aria-hidden', 'true');
        } else {
          this.style.removeProperty('display');
          this.style.removeProperty('visibility');
          this.removeAttribute('aria-hidden');
        }
      });
    }

    var shopPromiseVisibilityTimer = null;

    function scheduleShopPromiseVisibilityUpdate(delay) {
      if (shopPromiseVisibilityTimer) {
        clearTimeout(shopPromiseVisibilityTimer);
      }

      shopPromiseVisibilityTimer = setTimeout(function() {
        applyShopPromiseVisibility();
      }, typeof delay === 'number' ? delay : 0);
    }

    // AI3.0 Bet 11: gate shop-promise MutationObserver + cart-form handler +
    // initial schedule + setInterval to body#product only. `applyShopPromiseVisibility`
    // already early-returns off-PDP (line ~669), so on every non-PDP page the MO
    // fires on every DOM mutation, runs the schedule, fires applyShopPromiseVisibility,
    // and exits — pure waste. The cart-form handler targets `#cart-form` which is
    // PDP-only. See OUTPUT/_AI3_AUDIT_SITE_JS.md finding #1.
    if ($('body#product').length) {
      if (typeof MutationObserver !== 'undefined' && document.body) {
        new MutationObserver(function(mutations) {
          for (var i = 0; i < mutations.length; i++) {
            if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
              scheduleShopPromiseVisibilityUpdate(0);
              break;
            }
          }
        }).observe(document.body, {
          childList: true,
          subtree: true
        });
      }

      $(document).on('change', '#cart-form [name="id"]', function() {
        // AI3.0 Bet 7: collapsed redundant 0ms call.
        scheduleShopPromiseVisibilityUpdate(150);
      });

      // AI3.0 Bet 7: collapsed triple call (0, 500, 1500) — only 1500 fired.
      scheduleShopPromiseVisibilityUpdate(1500);

      setInterval(function() {
        scheduleShopPromiseVisibilityUpdate(0);
      }, 60000);
    }

    function handleVariantSelection($product, variant, selector) {
      if (!$product.length) {
        return;
      }

      var hasQuickviewStatus = getScopedQuickviewStatus($product).length > 0;
      var isPurchasable = !!(variant && variant.available === true);
      syncAccessoryAddAllInputs(selector.product.id, variant);
      var isQuickviewOnly = hasQuickviewStatus;
      var $uiScope = isQuickviewOnly ? $product : $('#product-details', $product).first();
      var $mainForm = isQuickviewOnly ? $() : $('#cart-form', $product).first();
      var $purchaseButton = isQuickviewOnly ? $('.purchase', $product).first() : $('#add-to-cart-button', $mainForm);
      var $varMsg = isQuickviewOnly ? $('.var-msg', $product).first() : $('.product-variants .var-msg', $mainForm).first();
      var $price = $('.product-price', $uiScope).first();
      var $comparePrice = $('.product-compare-price', $uiScope).first();
      var $sku = $('.variant-sku', $uiScope).first();
      var $mainQuickActions = isQuickviewOnly ? $() : $('.quick-actions', $mainForm).first();
      var $mainShippingStatus = isQuickviewOnly ? $() : $('.product-shipping-status', $uiScope).first();

      $varMsg.html('').hide();

      if (isQuickviewOnly) {
        togglePurchaseStateUI($product, isPurchasable);
      } else {
        if (isPurchasable) {
          $mainQuickActions.show();
          $mainShippingStatus.show();
        } else {
          $mainQuickActions.hide();
          $mainShippingStatus.hide();
          $('#shipping-status', $uiScope).html('');
        }
      }

      if (isPurchasable) {
        if (variant.featured_image != null && variant.featured_image.src) {
          if (isQuickviewOnly) {
            updateQuickviewMainImage($product, variant.featured_image.src);
          } else {
            updateMainProductImage($product, variant.featured_image.src, variant.featured_image.id);
          }
        }

        $purchaseButton.removeClass('disabled').removeAttr('disabled');
        $price.html(Shopify.formatMoney(variant.price, currencyFormat));

        if (variant.compare_at_price > variant.price) {
          $comparePrice.html(Shopify.formatMoney(variant.compare_at_price, currencyFormat));
        } else {
          $comparePrice.html('');
        }

        if ($sku.length > 0) {
          if (variant.sku) {
            $sku.text(variant.sku);
            $sku.parent('.sku-container').css('visibility', 'visible');
          } else {
            $sku.parent('.sku-container').css('visibility', 'hidden');
          }
        }

      } else {
        $price.html('');
        $comparePrice.html('');

        if ($sku.length > 0) {
          if (variant && variant.sku) {
            $sku.text(variant.sku);
            $sku.parent('.sku-container').css('visibility', 'visible');
          } else {
            $sku.parent('.sku-container').css('visibility', 'hidden');
          }
        }

        if (variant && variant.featured_image != null && variant.featured_image.src) {
          if (isQuickviewOnly) {
            updateQuickviewMainImage($product, variant.featured_image.src);
          } else {
            updateMainProductImage($product, variant.featured_image.src, variant.featured_image.id);
          }
        }

        $varMsg.html(getUnavailableMessageHtml(variant)).fadeIn(200);

        if (isQuickviewOnly) {
          $purchaseButton.text(themeI18nProducts.add_to_cart || "Add to Cart");
          getScopedQuickviewStatus($product).html('');
          $('.quick-actions', $product).hide();
          $('.quickview-shipping-status', $product).hide();
        }
      }

      if (isQuickviewOnly) {
        updateQuickviewInventoryUI($product, selector.product.id, variant);
        // AI3.0 Bet 7: collapsed redundant 0ms call — only the 150ms call ever fired.
        scheduleShopPromiseVisibilityUpdate(150);
        return;
      }

      if (variant) {
        window.variantInventory = {
          quantity: variant.inventory_quantity,
          policy: variant.inventory_policy,
          managed: variant.inventory_management
        };
        window.variantAvailable = variant.available;
      } else {
        window.variantInventory = null;
        window.variantAvailable = false;
      }

      window.variantInventoryState =
        (window.variantInventoryStates && variant && window.variantInventoryStates[variant.id]) ||
        window.productInventoryState ||
        "";

      $purchaseButton.text(getInventoryButtonText(window.variantInventoryState));

      if (isPurchasable) {
        $mainShippingStatus.show();
        if (typeof updateShippingStatus === "function") {
          updateShippingStatus();
        }
      } else {
        $('#shipping-status', $uiScope).html('');
        $mainShippingStatus.hide();
      }

      // AI3.0 Bet 7: collapsed triple call (0, 150, 500) — only the last fired.
      scheduleShopPromiseVisibilityUpdate(500);
    }

    window.selectCallback = function(variant, selector) {
      return handleVariantSelection($('#prod-' + selector.product.id), variant, selector);
    };

    window.selectCallback2 = function(variant, selector) {
        return handleVariantSelection($('#prod2-' + selector.product.id), variant, selector);
    };

});